import {
  ContentContainer,
  TicketQRCodeBackground,
  TicketWrapper,
  TicketImgBox,
  Ticket,
  QRTitleText,
  QRCodeWrppaer,
} from "./TicketQRcode.styles";
import { TextM, TextMS, TextS } from "../../common/text";
import { QRCodeSVG } from "qrcode.react";
import { useMediaQuery } from "react-responsive";

const TicketQRcode = ({ setIsCodeOpen, ticket }) => {
  const close = () => {
    setIsCodeOpen(false);
  };
  const isTablet = useMediaQuery({ minWidth: 768 });
  return (
    <ContentContainer onClick={close}>
      <TicketQRCodeBackground>
        <TicketWrapper>
          <TicketImgBox src={ticket.product.images[0]} />
          <Ticket>
            <QRTitleText>
              <TextM>{ticket.product.name}</TextM>
              <br />
              <TextMS>{ticket.validDate}</TextMS>
            </QRTitleText>
            <QRCodeWrppaer>
              <QRCodeSVG value={ticket.barcode} size={isTablet ? 200 : 100} />
              <TextS>{ticket.barcode}</TextS>
            </QRCodeWrppaer>
          </Ticket>
        </TicketWrapper>
      </TicketQRCodeBackground>
    </ContentContainer>
  );
};

export default TicketQRcode;
